import styled from "styled-components"
import ImgB from '../../img/Aterrizaje.jpg'

export const StyleBa = styled.div`
    background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1)), url(${ImgB});
    min-height: 500px;
    height: 100vh;
    background-position: center;
    background-size: cover;
    border-radius: 30px;
    margin-left: 250px;
    margin-bottom: 4.5rem;

    @media screen and (max-width: 375px) {
        background: none;
    }

    @media screen and (max-width: 900px) {
        background: none;
    }
`